<template>
  <div>
    <div class="w-all w-minw bd-sd-b hg-40 bg-c-ffffff">
      <div class="w-main m-auto">
        <div class="fr">
          <div class="hover-ucenter fl">
            <div class="top_ucenter fl fs-12 line-h40"></div>
          </div>

          <a class="fs-12 ftc-000000 line-h40 go-login more" href="/show" v-if="nickname!=null">
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>
            您好，{{nickname}}
          </a>
          <a
            class="fs-12 ftc-000000 line-h40 go-login more"
            href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
            v-if="nickname==null"
          >
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>您好，请登录
          </a>
          <a href="javascript:void(0)" @click="logout" v-if="nickname!=null" class="fs-12 ftc-000000 line-h40 m-l-4 more">[退出]</a>
          <a href="/login" v-if="nickname==null" class="fs-12 ftc-000000 line-h40 m-l-4 more"></a>
          <span class="fs-12 ftc-000000 line-h40 m-l-15">|</span>

          <div class="fr m-l-15">
            <div class="my-lesson">
              <a v-if="nickname!=null" href="/cglist" class="fl fs-12 ftc-000000 line-h40">
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
              <a
                v-if="nickname==null"
                href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
                class="fl fs-12 ftc-000000 line-h40"
              >
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="toppic wall mb10">
      <div class="picself wall">
        <ul>
          <li>
            <a href="/Show">首页</a>
          </li>
          <li>
            <a href="/Show">活动启事</a>
          </li>
          <li>
            <a href="/cgzp">课改成果展评</a>
          </li>
          <li>
            <a href="/lwzp">原创成果展评</a>
          </li>
          <li>
            <a href="/hjcx">获奖查询</a>
          </li>
        </ul>

        <!-- <a class="uploadfile" href="/bmcs">上传作品</a> -->
      </div>
    </div>
    <div class="main w1200">
      <div class="w1200">
        <div class="fl bghj">
          <div style="position:absolute">
            <img src="../assets/images/x_jian_y.png" class="x_jian" />
          </div>
          <div>
            <p class="f16" style="color:#028d7e; padding:30px 30px;">如果您在语文教育领域已有公开的课改成果，欢迎您参加——</p>
          </div>

          <div class="titlezp mb30">
            <img id="cgzp" src="../assets/images/title_cgzp.png" />
          </div>
          <div class="f14 of" style="padding:30px 30px;">
            <p class="f14 of">
              1.参评学术成果应符合新时代课改精神。
              <br />2.参评学术成果包括论文、专著和编著、课题、获奖公开课等。
              <br />3.参评学术成果内容不限，可以体现在资源开发、教材研究、教学设计、课堂展示、教学反思、课外拓展、评价考试等语文教学与研究的各个环节。
              <br />参评要求、参评办法和评奖程序等详见活动启事。
              <br />
              <span style="color:#fe5502;">★ 特别优秀者将推荐担任学术刊封面人物</span>
            </p>
          </div>
          <div class="mb30" style="width:321px;margin:0 auto;">
            <img
              v-if="nickname!=null"
              id="baoming_y"
              @click="toChengGuo"
              src="../assets/images/baoming_y.png"
            />
            <a
              v-if="nickname==null"
              href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
              hover="hand"
            >
              <img id="baoming_y" src="../assets/images/baoming_y.png" />
            </a>
          </div>
        </div>
        <div class="fr bghj">
          <div style="position:absolute">
            <img src="../assets/images/x_jian_b.png" class="x_jian" style="top:-53px;" />
          </div>
          <div>
            <p class="f16" style="color:#028d7e; padding:30px 30px;">如果您在语文教育领域已有公开的课改成果，欢迎您参加——</p>
          </div>

          <div class="titlezp mb30">
            <img id="cgzp" src="../assets/images/title_lwzp.png" />
          </div>
          <div class="f14 of" style="padding:30px 30px;">
            <p class="f14 of">
              1.参评作品包括未正式发表的学术论文和教学设计。
              <br />2.来稿可自择角度，自拟题目；倡导学术性与实践性并重，内容切实具体，文风扎实严谨；所涉及的教材版本信息也要明确。
              <br />3.参评作品必须保证是本人原创，不得抄袭他人成果、侵犯他人版权。
              <br />参评要求、参评办法和评奖程序等详见活动启事。
              <br />
              <span style="color:#fe5502;">★ 知网将全文收录获奖论文且颁发证书，等同于刊物发表</span>
            </p>
          </div>
          <div class="mb30" style="width:321px;margin:0 auto;">
         
              <img v-if="nickname!=null" id="baoming_b" @click="toLunWen" src="../assets/images/baoming_b.png" />
           
            <a
              v-if="nickname==null"
              href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
              hover="hand"
            >
              <img id="baoming_b" src="../assets/images/baoming_b.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="footer"
      style="background:url(('../../assets/images/foot.png')) top center no-repeat;"
    >
      <div class="menu">
        <div class="box">
          <a href="http://www.zhyww.cn/ywbs/bsjj/202006/115472.html" target="_blank">关于我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115483.html"
            target="_blank"
          >联系我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115484.html"
            target="_blank"
          >版权声明</a>
        </div>

        <div class="copyright">
          <p>语文网版权所有 未经书面授权 不得复制或建立镜像 晋公网安备14010902000073号</p>
          <p>
            增值电信业务经营许可证晋B2-20030007 新出网许（晋）字005号
            <a
              href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
              target="_blank"
            >晋ICP备09011058号</a>
            <a
              href="http://webscan.360.cn/index/checkwebsite/url/www.zhyww.cn"
              name="f7c1c8d71288f01cb16d63638e8f82bc"
            >网站安全检测平台</a>
          </p>
        </div>

        <a href="http://webscan.qianxin.com/safe/detail/?query=www.zhyww.cn">
          <img
            border="0"
            src="http://webscan.qianxin.com/api/authcode?code=fd753cb81c61b4824c3645292d170f85"
            style="display: none;"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/base.css";
import "@/assets/xspx.css";
export default {
  data() {
    return {
	  nickname: null,
	  username:null,
    };
  },
  created() {
	this.nickname = sessionStorage.getItem("nickname");
	
  },
  mounted: function() {},
  methods: {
    close: function() {
      this.$alert("活动已结束", "", {
        confirmButtonText: "确定"
      });
    },
    toChengGuo: function() {
      var that = this;
     var name= sessionStorage.getItem("username");
      if (name == 0) {
        that.$router.push({ path: "/userHome" });
      } else {
        that.$router.push({ path: "/cgList" });
      }
    },
	toLunWen: function() {
   var that = this;
    var name= sessionStorage.getItem("username");
      if (name == 0) {
        that.$router.push({ path: "/userHome" });
      } else {
        that.$router.push({ path: "/lwzp" });
      }
    
    },
      logout(){
    sessionStorage.clear();
     this.$router.push({ path: "/" });
  }
  },
};
</script>
